import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-xxl" }
const _hoisted_2 = { class: "d-flex justify-content-end mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "me-2 text-gray-600" }, "自动刷新:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise me-1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("刷新 ")
const _hoisted_7 = {
  key: 0,
  class: "ms-3 text-gray-500 fs-7"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill fs-4 text-primary me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "用户数据")
], -1)
const _hoisted_9 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_10 = { class: "col-xl-4" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "总用户数")
], -1)
const _hoisted_15 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_16 = { class: "col-xl-4" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "日付费用户")
], -1)
const _hoisted_21 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_22 = { class: "col-xl-4" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "周付费用户")
], -1)
const _hoisted_27 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-currency-exchange fs-4 text-info me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "流水数据")
], -1)
const _hoisted_29 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_30 = { class: "col-xl-4" }
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "日流水")
], -1)
const _hoisted_35 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_36 = { class: "col-xl-4" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "周流水")
], -1)
const _hoisted_41 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_42 = { class: "col-xl-4" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = { class: "card-body" }
const _hoisted_45 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "月流水")
], -1)
const _hoisted_47 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash-stack fs-4 text-success me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "充值数据")
], -1)
const _hoisted_49 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_50 = { class: "col-xl-4" }
const _hoisted_51 = { class: "card" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "日充值")
], -1)
const _hoisted_55 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_56 = { class: "col-xl-4" }
const _hoisted_57 = { class: "card" }
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "周充值")
], -1)
const _hoisted_61 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_62 = { class: "col-xl-4" }
const _hoisted_63 = { class: "card" }
const _hoisted_64 = { class: "card-body" }
const _hoisted_65 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "月充值")
], -1)
const _hoisted_67 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow fs-4 text-warning me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "毛利数据")
], -1)
const _hoisted_69 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_70 = { class: "col-xl-4" }
const _hoisted_71 = { class: "card" }
const _hoisted_72 = { class: "card-body" }
const _hoisted_73 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "日毛利")
], -1)
const _hoisted_75 = { class: "col-xl-4" }
const _hoisted_76 = { class: "card" }
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "周毛利")
], -1)
const _hoisted_80 = { class: "col-xl-4" }
const _hoisted_81 = { class: "card" }
const _hoisted_82 = { class: "card-body" }
const _hoisted_83 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "月毛利")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash-coin fs-4 text-primary me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "本月真实净利润"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7 ms-3" }, "= 月毛利 + 月运营成本（含通道费、快递、服务器等）")
], -1)
const _hoisted_86 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_87 = { class: "col-xl-4" }
const _hoisted_88 = { class: "card" }
const _hoisted_89 = { class: "card-body" }
const _hoisted_90 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "月毛利(同上)")
], -1)
const _hoisted_92 = { class: "col-xl-4" }
const _hoisted_93 = { class: "card" }
const _hoisted_94 = { class: "card-body" }
const _hoisted_95 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "月运营成本")
], -1)
const _hoisted_97 = { class: "fw-bolder fs-3 text-danger" }
const _hoisted_98 = { class: "col-xl-4" }
const _hoisted_99 = { class: "card border-primary" }
const _hoisted_100 = { class: "card-body bg-light-primary" }
const _hoisted_101 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "真实净利润")
], -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wallet2 fs-4 text-danger me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "用户资产")
], -1)
const _hoisted_104 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_105 = { class: "col-xl-4" }
const _hoisted_106 = { class: "card" }
const _hoisted_107 = { class: "card-body" }
const _hoisted_108 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_109 = { class: "me-2" }
const _hoisted_110 = { class: "fw-bolder text-gray-800 d-block fs-3" }
const _hoisted_111 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_112 = { class: "col-xl-4" }
const _hoisted_113 = { class: "card" }
const _hoisted_114 = { class: "card-body" }
const _hoisted_115 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_116 = { class: "me-2" }
const _hoisted_117 = { class: "fw-bolder text-gray-800 d-block fs-3" }
const _hoisted_118 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_119 = { class: "col-xl-4" }
const _hoisted_120 = { class: "card" }
const _hoisted_121 = { class: "card-body" }
const _hoisted_122 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "总积分")
], -1)
const _hoisted_124 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_125 = { class: "col-xl-4" }
const _hoisted_126 = { class: "card" }
const _hoisted_127 = { class: "card-body" }
const _hoisted_128 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "背包余额")
], -1)
const _hoisted_130 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_131 = { class: "col-xl-4" }
const _hoisted_132 = { class: "card" }
const _hoisted_133 = { class: "card-body" }
const _hoisted_134 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "待发货")
], -1)
const _hoisted_136 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_137 = { class: "col-xl-4" }
const _hoisted_138 = { class: "card" }
const _hoisted_139 = { class: "card-body" }
const _hoisted_140 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "已发货")
], -1)
const _hoisted_142 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_143 = { class: "col-xl-4" }
const _hoisted_144 = { class: "card" }
const _hoisted_145 = { class: "card-body" }
const _hoisted_146 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "当月发货")
], -1)
const _hoisted_148 = { class: "fw-bolder fs-3 text-primary" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart-fill fs-4 text-dark me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "平台汇总")
], -1)
const _hoisted_150 = { class: "row gy-5 g-xl-8 mb-8" }
const _hoisted_151 = { class: "col-xl-4" }
const _hoisted_152 = { class: "card" }
const _hoisted_153 = { class: "card-body" }
const _hoisted_154 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "总充值")
], -1)
const _hoisted_156 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_157 = { class: "col-xl-4" }
const _hoisted_158 = { class: "card" }
const _hoisted_159 = { class: "card-body" }
const _hoisted_160 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "平台成本")
], -1)
const _hoisted_162 = { class: "fw-bolder fs-3 text-danger" }
const _hoisted_163 = { class: "col-xl-4" }
const _hoisted_164 = { class: "card" }
const _hoisted_165 = { class: "card-body" }
const _hoisted_166 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "总盈亏")
], -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trophy-fill fs-4 text-warning me-2" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-gray-800 mb-0" }, "排名数据")
], -1)
const _hoisted_169 = { class: "row gy-5 g-xl-8 mb-5" }
const _hoisted_170 = { class: "col-xl-6" }
const _hoisted_171 = { class: "card" }
const _hoisted_172 = { class: "card-body" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "流水排名")
  ])
], -1)
const _hoisted_174 = { class: "block py-3" }
const _hoisted_175 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_176 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "名次"),
    /*#__PURE__*/_createElementVNode("th", null, "昵称"),
    /*#__PURE__*/_createElementVNode("th", null, "流水"),
    /*#__PURE__*/_createElementVNode("th", null, "手机号")
  ])
], -1)
const _hoisted_178 = { class: "col-xl-6" }
const _hoisted_179 = { class: "card" }
const _hoisted_180 = { class: "card-body" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-3 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "亏损排名")
  ])
], -1)
const _hoisted_182 = { class: "block py-3" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_184 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "名次"),
    /*#__PURE__*/_createElementVNode("th", null, "昵称"),
    /*#__PURE__*/_createElementVNode("th", null, "亏损"),
    /*#__PURE__*/_createElementVNode("th", null, "手机号")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_select, {
          modelValue: _ctx.autoRefreshInterval,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autoRefreshInterval) = $event)),
          size: "small",
          style: {"width":"120px"},
          onChange: _ctx.handleAutoRefreshChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "关闭",
              value: 0
            }),
            _createVNode(_component_el_option, {
              label: "30秒",
              value: 30
            }),
            _createVNode(_component_el_option, {
              label: "1分钟",
              value: 60
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_button, {
          class: "ms-2",
          size: "small",
          onClick: _ctx.refreshData,
          loading: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        (_ctx.lastRefreshTime)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 上次更新: " + _toDisplayString(_ctx.lastRefreshTime), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.summary.user_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.summary.user_day_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.summary.user_week_total), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.summary.water_day_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.summary.water_week_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.summary.water_month_total), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_48,
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.summary.recharge_day_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.summary.recharge_week_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.summary.recharge_month_total), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_68,
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColorClass(_ctx.summary.profit_day_total)])
              }, _toDisplayString(_ctx.summary.profit_day_total), 3)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColorClass(_ctx.summary.profit_week_total)])
              }, _toDisplayString(_ctx.summary.profit_week_total), 3)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColorClass(_ctx.summary.profit_month_total)])
              }, _toDisplayString(_ctx.summary.profit_month_total), 3)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_85,
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColorClass(_ctx.monthlySummary.profit_sum)])
              }, _toDisplayString(_ctx.formatMoney(_ctx.monthlySummary.profit_sum)), 3)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _hoisted_96,
              _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.formatMoney(_ctx.monthlySummary.total_cost)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-2", _ctx.valueColorClass(_ctx.monthlySummary.net_profit)])
              }, _toDisplayString(_ctx.formatMoney(_ctx.monthlySummary.net_profit)), 3)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_103,
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("span", _hoisted_110, "总" + _toDisplayString(_ctx.balanceLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.summary.balance_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("span", _hoisted_117, "总" + _toDisplayString(_ctx.pointLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.summary.point_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_119, [
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _hoisted_123,
              _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.summary.membership_point_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_125, [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _hoisted_129,
              _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.summary.pending_pocket_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_131, [
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _hoisted_135,
              _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.summary.delivering_pocket_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_137, [
        _createElementVNode("div", _hoisted_138, [
          _createElementVNode("div", _hoisted_139, [
            _createElementVNode("div", _hoisted_140, [
              _hoisted_141,
              _createElementVNode("div", _hoisted_142, _toDisplayString(_ctx.summary.delivered_pocket_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_143, [
        _createElementVNode("div", _hoisted_144, [
          _createElementVNode("div", _hoisted_145, [
            _createElementVNode("div", _hoisted_146, [
              _hoisted_147,
              _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.summary.delivered_pocket_month_total || 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_149,
    _createElementVNode("div", _hoisted_150, [
      _createElementVNode("div", _hoisted_151, [
        _createElementVNode("div", _hoisted_152, [
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("div", _hoisted_154, [
              _hoisted_155,
              _createElementVNode("div", _hoisted_156, _toDisplayString(_ctx.summary.add_balance_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_157, [
        _createElementVNode("div", _hoisted_158, [
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("div", _hoisted_160, [
              _hoisted_161,
              _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.summary.platform_total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_163, [
        _createElementVNode("div", _hoisted_164, [
          _createElementVNode("div", _hoisted_165, [
            _createElementVNode("div", _hoisted_166, [
              _hoisted_167,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", _ctx.valueColorClass(_ctx.summary.profit_total)])
              }, _toDisplayString(_ctx.summary.profit_total), 3)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_168,
    _createElementVNode("div", _hoisted_169, [
      _createElementVNode("div", _hoisted_170, [
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _hoisted_173,
            _createElementVNode("div", _hoisted_174, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.water_duration,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.water_duration) = $event)),
                type: "datetimerange",
                "range-separator": " - ",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, { onClick: _ctx.water_submit }, {
                default: _withCtx(() => [
                  _hoisted_175
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("table", _hoisted_176, [
              _hoisted_177,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.water_list, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nickname), 1),
                    _createElementVNode("td", null, _toDisplayString(item.amount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mobile), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_178, [
        _createElementVNode("div", _hoisted_179, [
          _createElementVNode("div", _hoisted_180, [
            _hoisted_181,
            _createElementVNode("div", _hoisted_182, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.loser_duration,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loser_duration) = $event)),
                type: "datetimerange",
                "range-separator": " - ",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, { onClick: _ctx.loser_submit }, {
                default: _withCtx(() => [
                  _hoisted_183
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("table", _hoisted_184, [
              _hoisted_185,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loser_list, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nickname), 1),
                    _createElementVNode("td", null, _toDisplayString(item.amount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mobile), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}